async function createCustomerAccessToken(email, password) {
  console.log('[REA][REAAuth] createCustomerAccessToken called for email:', email);
  let storefrontToken = document.getElementById('storefront-access-token')?.value;
  let storefrontEndpoint = document.getElementById('storefront-endpoint')?.value;

  // Fallback to localStorage if not found
  if (!storefrontToken) {
    storefrontToken = localStorage.getItem('storefrontToken');
  }
  if (!storefrontEndpoint) {
    storefrontEndpoint = localStorage.getItem('storefrontEndpoint');
  }

  if (!storefrontToken || !storefrontEndpoint) {
    console.error('[REA][REAAuth] Token o endpoint Storefront mancante — storefrontToken:', !!storefrontToken, 'storefrontEndpoint:', !!storefrontEndpoint);
    return { success: false, error: 'Missing storefront configuration' };
  }

  // Save to localStorage for future use
  try {
    localStorage.setItem('storefrontToken', storefrontToken);
    localStorage.setItem('storefrontEndpoint', storefrontEndpoint);
  } catch (e) {
    // ignore
  }

  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: { email, password }
  };

  try {
    console.log('[REA][REAAuth] sending GraphQL request to', storefrontEndpoint);
    const response = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query, variables })
    });

    console.log('[REA][REAAuth] fetch status', response.status);
    const result = await response.json();
    console.log('[REA][REAAuth] GraphQL response', result);
    const data = result?.data?.customerAccessTokenCreate;

    if (data?.customerAccessToken?.accessToken) {
      const token = data.customerAccessToken.accessToken;
      // Save token and onboarding flag in sessionStorage (per-session scope)
      try {
        sessionStorage.setItem('customerAccessToken', token);
        localStorage.setItem('is-account-new', 'true');
        console.log('[REA][REAAuth] sessionStorage.customerAccessToken set');
      } catch (err) {
        // Fallback to localStorage if sessionStorage is unavailable
        console.warn('[REA][REAAuth] sessionStorage unavailable, falling back to localStorage:', err);
        localStorage.setItem('customerAccessToken', token);
        localStorage.setItem('is-account-new', 'true');
        console.log('[REA][REAAuth] localStorage.customerAccessToken set');
      }
      return { success: true, token };
    }

    console.warn('[REA][REAAuth] Errore nella creazione del token:', data?.customerUserErrors);
    return { success: false, errors: data?.customerUserErrors || [] };
  } catch (error) {
    console.error('[REA][REAAuth] Errore nella richiesta GraphQL:', error);
    return { success: false, error };
  }
}

window.REAAuth = {
  createCustomerAccessToken
};
